import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loading } from '../components/states';
import { useAuth } from './AuthProvider';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'restoring') return <Loading label="Restoring your session" />;
  // The query string comes back too (an OAuth consent link carries its request there)
  if (status === 'signed_out') return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  return <Outlet />;
}

export function RedirectIfSignedIn({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  if (status === 'restoring') return <Loading label="Restoring your session" />;
  if (status === 'signed_in') return <Navigate to="/agencies" replace />;
  return <>{children}</>;
}
